export default "__VITE_ASSET__Bn4FzUNs__"